
    // IMPORTS
    import { computed, defineComponent, onMounted, ref } from 'vue'
    import { buildLocalization, SyncEventApi } from '@/util'
    import myGrid from '@/components/grid/my-grid.vue'
    import { SortDescriptor } from '@progress/kendo-data-query'    
    import { GridColumnProps } from '@progress/kendo-vue-grid'
    import { ISyncEventDTO } from '@/types/ISyncEventDTO'

    export default defineComponent({
        name: 'adminSyncEventList',

        components: {
            myGrid
        },

        setup() {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/

            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const allSyncEvents = ref<ISyncEventDTO[] | null>(null)

            const publicData = { allSyncEvents }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const initialSort = computed<SortDescriptor[]>(() => [ { field: 'whenIsoString', dir: 'desc' } ] )

            const columns = computed(() => {
                {
                return [
                    {
                        field: 'whenIsoString',
                        title: localize('Time'),
                        width: 150,
                        cell: 'dateTime'
                    },
                    {
                        field: 'eventName',
                        title: localize('EventName'),
                        width: 150
                    },
                    {
                        field: 'description',
                        title: localize('Description'),
                        cell: 'custom1'
                    }
                ] as GridColumnProps[]
            }})

            const computedData = { initialSort, columns }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const { localize } = buildLocalization();

            const publicMethods = { localize }

            /********************************************************************************************************************
             PRIVATE METHODS
             ********************************************************************************************************************/
            function loadEvents() {
                const api = new SyncEventApi

                api.getEvents()
                    .then(response => setEvents(response.data))
            }

            function setEvents(events: ISyncEventDTO[]) {
                allSyncEvents.value = events.map(e => convertEvent(e))
            }

            function convertEvent(event: ISyncEventDTO): ISyncEventDTO {
                return {
                    eventName: event.eventName,
                    description: event.description,
                    whenIsoString: event.whenIsoString
                }
            }

            /********************************************************************************************************************
             LIFE-CYCLE HOOKS
             ********************************************************************************************************************/
            onMounted(() => loadEvents()) 

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
